import { capitalizeFirstLetter } from 'src/utils/capitalizeFirstLetter';

// Differs from channelToDisplayName (which maps widget → "Chat",
// playbook → "Assist"). Use this helper for table cells/badges that
// show the channel id capitalized verbatim.
export const formatChannelLabel = (channel: string): string =>
  channel === 'api' ? 'Headless' : capitalizeFirstLetter(channel);
